import axios from "axios";
import { getCurrentInstance } from "vue";

export class HttpService {
  baseUrl = process.env.VUE_APP_SITE_URL_API;
  constructor() {
    const app = getCurrentInstance().appContext.config.globalProperties;
    this.baseUrl = app.$config.SITE_URL_API;
  }

  async get(url) {
    const response = await axios.get(`${this.baseUrl}/${url}`);
    return response.data;
  }

  async post(url, body) {
    const response = await axios.post(`${this.baseUrl}/${url}`, body);
    return response.data;
  }
}